                
import React,{useState,useEffect} from 'react';
import styled from "styled-components"; 
import GoogleAnalyticsEvent from "../background/GoogleAnalyticsEvent.js";

import PageSectionHeadline from "./PageSectionHeadline"
import Button from 'react-bootstrap/Button'
import DropdownButton from 'react-bootstrap/DropdownButton'
import Dropdown from 'react-bootstrap/Dropdown'

const Tab = styled(Button)`
    background-color:#FFFFFF; 
    color:blue; 
    border:0px; 
    text-decoration:underline; 
    margin-top:5px; 
    outline: none !important;
    &:hover{ 
        background-color:#FFFFFF; 
        font-weight:bold; 
        color:blue; 
        outline: none !important;
    }
    &:active{ 
        background-color:#FFFFFF; 
        font-weight:bold; 
        color:blue; 
        outline: none !important;
    }
    &:focus{ 
        background-color:#FFFFFF; 
        font-weight:bold; 
        color:blue; 
        outline: none !important;
    }
`;



export default function SampleItineraries({ id,sectionHeadline,displayFirst,panes,color }) {

    let displayFirstIndex = 0; 

    if(displayFirst!==undefined && displayFirst!==''){ 
        displayFirstIndex = getPaneIndexFromKey(displayFirst); 
    } 


    function getPaneIndexFromKey(key){ 
        for(let p=0;p<panes.length;p++){
            if(panes[p].key===key){ 
                return p; 
            }
        }
        return 0; 
    }

    if(color===undefined) color="red"; 
    let title_color; 

    if(color==="red"){ 
        title_color = 'yellow'; 
    } else if(color==="blue"){ 
        title_color = 'green'; 
    }else if(color==="orange"){ 
        title_color = 'blue'; 
    }

    const [sectionHeadlineColor] = useState(color);
    const [sectionTitleColor] = useState(title_color);
    const [currentPane,setCurrentPane] = useState(displayFirstIndex);
    const [transitionToPane,setTransitionToPane] = useState(null);
    const [transitioningOut,setTransitioningOut] = useState(false); 
    const [transitioningIn,setTransitioningIn] = useState(true); 

    const timeout = 1000; // total animation durations

    useEffect(() => {
        if(transitionToPane!==null){
            setTransitioningOut(true); 

            const timer = setTimeout(() => {
                setCurrentPane(transitionToPane);
                setTransitioningIn(true); 
                setTransitioningOut(false); 
            }, timeout);
            return () => clearTimeout(timer);
        }
    },[transitionToPane]);

    useEffect(() => {
        setTransitioningIn(true); 
        setTransitioningOut(false); 
    },[currentPane]);

    function transitionPane(toPaneKey){ 
        setTransitionToPane(getPaneIndexFromKey(toPaneKey));
        GoogleAnalyticsEvent("sampleitinerary_interaction",{to:toPaneKey})
    }

    return (
        <>
        <PageSectionHeadline id={`${id}_Headline`} color={sectionHeadlineColor}>{sectionHeadline}</PageSectionHeadline>

        <div class="sample-itineraries" id={`${id}_Content`}>
            <div className="itinerary-tabs">
                <div className={`itinerary-tab-inner ${transitioningIn ? "entering" : ""}  ${transitioningOut ? "exiting" : ""}`}>
                    <div className={`currentPaneTitle ${sectionTitleColor}`}>
                        <h3>{panes[currentPane].headline}</h3>
                        <svg data-name="TabBG" className="maincolorblock" xmlns="http://www.w3.org/2000/svg" width="800" height="59" viewBox="0 0 800 59">
                            <path class="bg" d="M742.9814,59H0V1H799.9814s-44,12.4286-54,58Z"/>
                        </svg>
                        <svg data-name="Headline BG" className="left-angle" xmlns="http://www.w3.org/2000/svg" width="30" height="60" viewBox="0 0 30 60">
                            <polygon class="left-angle" points="0 0 0 60 30 60 0 0"/>
                        </svg>
                    </div>

                {/* Large Screen Version of Other Tabs */}
                    <div className="other-tabs-label">{ (panes.length>2) ? 'Other Ideas:':'Another Idea:'}</div>
                    { panes.filter(function(pane,index) {
                                    if(index===currentPane){ return false; }
                                    return true;
                                    }).map((pane,index) => { 
                                        return (<Tab key={"gotopane"+index} className="tab" onClick={(e)=>{transitionPane(pane.key);}}>{pane.linktext}</Tab>);
                                    }) }

                {/* Dropdown Version of Other Tabs for XS - LARGE */}
                <div className="other-tabs-dropdown-container">
                    <DropdownButton id={`${id}_OtherDropdown`} title={ (panes.length>2) ? 'More Vacation Ideas':'Another Vacation Idea'} size="sm">                            
                        { panes.filter(function(pane,index) {
                                if(index===currentPane){ return false; }
                                return true;
                                }).map((pane,index) => { 
                                    return (<Dropdown.Item key={"gotopane"+index} onClick={(e)=>{transitionPane(pane.key);}}>{pane.linktext}</Dropdown.Item>);
                                }) }
                    </DropdownButton>
                </div>
                </div>
            </div>
            
            <div className={`itinerary-content ${sectionHeadlineColor} ${transitioningIn ? "entering" : ""}  ${transitioningOut ? "exiting" : ""}`}>
                {panes[currentPane].content}
            </div>
        </div>
        <div class="sample-itineraries-other-tabs">
            { panes.filter(function(pane,index) {
                            if(index===currentPane){ return false; }
                            return true;
                            }).map((pane) => { 
                                return (<div key={"other-tab-"+pane.key} className={"other-tab-"+pane.key}>
                                          <h3>{pane.headline}</h3>
                                          {pane.content}
                                        </div> );
                            }) }
        </div>
        </>
    )
}








